import { Directive, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[mstarAfterViewInit]'
})
export class AfterViewInitDirective implements AfterViewInit {

  @Output('mstarAfterViewInit') afterViewInit: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngAfterViewInit() {
    this.afterViewInit.emit();
  }
}
